import { SET_NEWS } from '../constants/constants'

// eslint-disable-next-line default-param-last
const newsDetail = (state = {}, action) => {
    if (action.type === SET_NEWS) {
        return action.payload
    }

    return state
}

export default newsDetail
